export const categories = [
  { slug: 'wanghong-heiliao', name: '网红黑料', description: '追踪网红圈最新黑料，深扒人设背后的真相', icon: 'ri-spy-line', heroImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20social%20media%20influencer%20scandal%20abstract%20background%20warm%20red%20amber%20lighting%20mysterious%20atmosphere%20cinematic%20editorial&width=1600&height=900&seq=cat-hero-wanghong&orientation=landscape' },
  { slug: 'meiri-dasai', name: '每日大赛', description: '吃瓜群众每日必看，精彩大赛实时追踪', icon: 'ri-fire-line', heroImage: 'https://readdy.ai/api/search-image?query=Dark%20intense%20competition%20show%20abstract%20background%20dramatic%20red%20gold%20lighting%20fiery%20atmosphere%20cinematic%20editorial%20quality&width=1600&height=900&seq=cat-hero-meiri&orientation=landscape' },
  { slug: 'heiliao-budayang', name: '黑料不打烊', description: '24小时不打烊，黑料持续更新永不间断', icon: 'ri-moon-clear-line', heroImage: 'https://readdy.ai/api/search-image?query=Dark%20nighttime%20mysterious%20abstract%20background%20deep%20red%20black%20gradient%20midnight%20atmosphere%20nocturnal%20mood%20cinematic%20editorial&width=1600&height=900&seq=cat-hero-heiliao&orientation=landscape' },
  { slug: 'mingxing-bagua', name: '明星八卦', description: '娱乐圈最新八卦资讯，明星动态一手掌握', icon: 'ri-star-line', heroImage: 'https://readdy.ai/api/search-image?query=Dark%20glamorous%20celebrity%20red%20carpet%20abstract%20background%20gold%20amber%20lighting%20luxury%20elegant%20cinematic%20editorial%20quality&width=1600&height=900&seq=cat-hero-mingxing&orientation=landscape' },
  { slug: 'chigua-qianxian', name: '吃瓜前线', description: '第一手吃瓜资讯，热门事件抢先看', icon: 'ri-chat-smile-2-line', heroImage: 'https://readdy.ai/api/search-image?query=Dark%20exciting%20breaking%20news%20abstract%20background%20warm%20vibrant%20red%20amber%20gradient%20dynamic%20atmosphere%20cinematic%20editorial&width=1600&height=900&seq=cat-hero-chigua&orientation=landscape' },
];

export const articles = [
  {
    id: 1,
    title: '某千万粉丝网红深夜直播翻车，粉丝集体脱粉回踩',
    slug: 'wanghong-zhibo-fanche',
    excerpt: '拥有超过两千万粉丝的知名网红在深夜直播中出现重大失误，引发粉丝大规模脱粉。据知情人士透露，该网红此前多次被质疑人设造假，此次事件成为压垮骆驼的最后一根稻草。',
    content: `<p>近日，某拥有超过两千万粉丝的头部网红在深夜直播时遭遇了职业生涯最大的一次翻车事件。</p><p>据观看直播的网友描述，该网红在直播过程中疑似饮酒过量，言语间暴露了多个此前精心维护的人设破绽。从"独立女性创业者"到"正能量偶像"，多个标签被网友逐条拆解。</p><p>事件发酵后，该网红多个粉丝群出现大规模退群现象。有资深粉丝在社交平台发文表示："追了三年，没想到全是演出来的，心累了。"</p><p>截至发稿前，该网红尚未对此事件作出任何回应，但其社交账号已关闭评论功能。据业内人士分析，此次事件或将对她的商业代言价值造成至少千万级别的损失。</p><p>值得一提的是，这已经不是该网红第一次陷入争议。去年她曾被前合作伙伴爆料拖欠分成，当时虽然以和解告终，但已埋下了信任危机的种子。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    author: '吃瓜小编',
    readCount: '18.6w',
    hotIndex: 98,
    publishDate: '2026-07-06',
    publishTime: '23:15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20gossip%20background%20dramatic%20lighting%20mysterious%20atmosphere%20cinematic%20style%20warm%20amber%20deep%20red%20tones%20abstract%20composition%20subtle%20texture%20editorial%20photography%20mood&width=560&height=352&seq=article-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '娱乐圈知名夫妻档被爆已分居半年，工作室紧急辟谣',
    slug: 'yulequan-fenju',
    excerpt: '曾被粉丝誉为"神仙眷侣"的某娱乐圈夫妻档，近日被多名圈内人士爆料已分居超过半年。双方工作室虽紧急发布辟谣声明，但网友发现多处细节疑点重重。',
    content: `<p>曾被广大粉丝誉为娱乐圈"神仙眷侣"的某知名夫妻档，近日被曝出已经分居超过半年的重磅消息。</p><p>据多名圈内知情人士透露，两人自去年年底起便已各自居住在不同住所，共同出席的活动也明显减少。有媒体统计，两人近半年同框次数仅两次，且均是在商业活动上，全程零交流。</p><p>消息传出后，双方工作室几乎同时发布声明，称"相关传闻纯属捏造，将保留追究法律责任的权利"。然而，细心的网友发现，两人在社交平台的互动已停滞数月，各自发布的动态中也不见对方身影。</p><p>更令人生疑的是，两人的共同商业代言在近期纷纷到期后并未续约，多个联名品牌也悄然下架了相关产品。一位不愿透露姓名的品牌方工作人员向本网确认了合作终止的事实，但拒绝透露具体原因。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '娱乐圈观察员',
    readCount: '25.3w',
    hotIndex: 95,
    publishDate: '2026-07-06',
    publishTime: '20:30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20celebrity%20couple%20drama%20dark%20elegant%20cinematic%20style%20mysterious%20mood%20red%20carpet%20theme%20warm%20lighting%20editorial%20quality&width=560&height=352&seq=article-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '某选秀节目人气选手被实锤学历造假，主办方连夜发声明',
    slug: 'xuanxiu-xueli-zaojia',
    excerpt: '正当红的某选秀节目人气选手被网友实锤学历造假，其晒出的名校毕业证被校友会公开打假。事件持续发酵，节目主办方连夜发布声明宣布该选手退出比赛。',
    content: `<p>正当红的某大型选秀节目播出期间，一位人气选手被网友扒出学历造假，引发轩然大波。</p><p>该选手此前在节目中多次提及自己的名校背景，并晒出毕业证书作为"学霸人设"的佐证。然而，有细心网友发现毕业证上的印章格式与该校真实版本存在明显差异。随后，该校校友会在官方平台发布声明，确认该选手并非该校毕业生。</p><p>事件曝光后，节目主办方连夜召开紧急会议，并于凌晨发布声明，宣布该选手即刻退出比赛，其已录制的镜头将全部删除。声明中还表示将加强参赛选手的背景审核机制。</p><p>该选手随后在个人社交账号发布长文致歉，承认在"巨大的名利诱惑下做出了错误的决定"。不过，网友们对此似乎并不买账，评论区一片嘲讽之声。</p>`,
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '赛事前线记者',
    readCount: '32.1w',
    hotIndex: 99,
    publishDate: '2026-07-07',
    publishTime: '09:45',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20stage%20dramatic%20spotlight%20controversy%20mood%20dark%20atmosphere%20theatrical%20lighting%20red%20gold%20tones%20editorial%20photography&width=560&height=352&seq=article-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '顶流女主播被前助理实名举报偷税漏税，金额高达数千万',
    slug: 'zhubo-toushui-loushui',
    excerpt: '某平台顶流女主播遭前助理实名举报，指控其通过多种手段偷逃税款，金额高达数千万元。税务部门已回应称正在核查相关线索。',
    content: `<p>直播行业再爆税务问题。某头部直播平台的顶流女主播被前助理实名举报，指控其在过去三年间通过多种手段偷逃巨额税款。</p><p>根据举报材料显示，该主播通过设立多家空壳公司、拆分合同金额、虚构成本支出等方式，涉嫌偷逃个人所得税及增值税，累计金额高达数千万元。举报人还提供了多份内部财务记录作为证据。</p><p>此事引发社会广泛关注，相关话题迅速登上热搜榜首。税务部门在回应媒体询问时表示，已收到相关举报材料，正在依法依规进行核查。</p><p>该主播的经纪团队随后发布声明，称前助理因被辞退而怀恨在心，举报内容纯属诬告。但声明中并未对具体的财务问题作出正面回应，这也引发了更多质疑。</p>`,
    category: '黑料不打烊',
    categorySlug: 'heiliao-budayang',
    author: '财税观察员',
    readCount: '45.8w',
    hotIndex: 100,
    publishDate: '2026-07-07',
    publishTime: '14:20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20livestream%20studio%20dramatic%20lighting%20financial%20scandal%20mood%20dark%20luxury%20atmosphere%20red%20black%20gold%20tones%20cinematic%20editorial%20style&width=560&height=352&seq=article-card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '知名美食博主被扒出所有探店视频均为收费推广',
    slug: 'meishi-bozhu-tuiguang',
    excerpt: '拥有数百万粉丝的知名美食博主被扒出所有"真心推荐"的探店内容均为收费推广。网友发现每家店内都有相同的隐藏机位，且有商家晒出高额推广合同。',
    content: `<p>"真诚推荐"还是"收费推广"？近日，一位拥有数百万粉丝的知名美食博主被扒出其所有探店视频均为商业推广，引发粉丝强烈不满。</p><p>事件的起因是有网友发现该博主的多条探店视频中，镜头角度和运镜方式惊人地一致，疑似使用了固定的拍摄团队和隐藏机位。随后，有餐厅老板在社交平台晒出了与该博主团队签订的推广合同，单条视频报价高达六位数。</p><p>更有意思的是，该博主此前多次在视频中强调"不接广告""都是真心推荐"，甚至曾在直播中怒怼质疑其收费推广的网友，称对方"以小人之心度君子之腹"。</p><p>事件曝光后，该博主的粉丝数在一夜之间暴跌近五十万。有粉丝在评论区留言："不是不能接广告，但是骗人就不对了。"目前该博主已将所有视频设为仅粉丝可见，并未作出公开回应。</p>`,
    category: '吃瓜前线',
    categorySlug: 'chigua-qianxian',
    author: '消费维权记者',
    readCount: '21.4w',
    hotIndex: 92,
    publishDate: '2026-07-05',
    publishTime: '16:50',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20food%20blogger%20restaurant%20review%20dramatic%20exposure%20mood%20warm%20amber%20lighting%20dark%20contrast%20editorial%20photography%20mysterious%20atmosphere&width=560&height=352&seq=article-card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '某短视频平台大V被曝私生活混乱，多名女性联合发声',
    slug: 'duanshipin-dav-sishenghuo',
    excerpt: '某短视频平台拥有千万粉丝的男性大V被多名女性联合指控，称其利用网红身份同时与多人保持不当关系。平台方已介入调查。',
    content: `<p>短视频平台的又一位头部创作者陷入了私生活争议。拥有超过千万粉丝的某男性大V近日被多名女性联合发声，指控其在过去两年间利用网红身份与多人同时保持恋爱关系。</p><p>根据其中一位当事人的叙述，该大V在与她交往期间，同时与至少五位女性保持着不同程度的亲密关系，且对每个人都声称"你是我唯一的真爱"。当事人们通过社交媒体相识后才发现这一惊人事实。</p><p>更令人震惊的是，据当事人透露，该大V还曾以"投资项目"为由，向多名女性借款，总金额超过百万元，至今未归还。</p><p>平台方在事件发酵后发布公告，表示已关注到相关舆情，将对此事进行调查。该大V目前已暂停更新，其商务合作方也纷纷宣布解约。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    author: '社会调查记者',
    readCount: '38.9w',
    hotIndex: 97,
    publishDate: '2026-07-06',
    publishTime: '11:05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20social%20media%20scandal%20dramatic%20lighting%20dark%20mysterious%20mood%20red%20black%20tones%20abstract%20composition%20editorial%20photography%20high%20contrast&width=560&height=352&seq=article-card-06&orientation=landscape',
  },
  {
    id: 7,
    title: '年度最大反转：被骂"渣男"三个月的男星竟是被诬陷',
    slug: 'niandu-fanzhuan-nanxing',
    excerpt: '被全网骂了整整三个月的某男星，今日终于等来了真相大白。前女友在社交平台发布道歉声明，承认所有指控均为编造，目的是报复分手。',
    content: `<p>年度最大反转来了！被全网网暴整整三个月的某知名男星，终于等到了真相大白的这一天。</p><p>三个月前，该男星的前女友在社交平台发布长文，控诉其在恋爱期间出轨、冷暴力等多条"罪状"。文章发出后迅速引爆网络，该男星一夜之间成为全网公敌，多个品牌火速解约，已拍摄完成的影视作品也被无限期延播。</p><p>然而，今日该前女友突然发布道歉声明，承认此前所有指控均为编造。"因为分手的不甘心，我选择了编造谎言来报复他。这三个月来我看着他被网暴，良心一直备受煎熬。"她在声明中写道。</p><p>道歉声明发布后，舆论再次反转。不少网友纷纷表示愧疚，但该男星三个月来遭受的损失已无法挽回。他在回应中仅表示"接受道歉，但需要一个公道"。据悉，其律师团队已启动名誉权诉讼程序。</p>`,
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '深度调查组',
    readCount: '52.6w',
    hotIndex: 99,
    publishDate: '2026-07-07',
    publishTime: '08:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20plot%20twist%20dramatic%20reveal%20cinematic%20lighting%20golden%20hour%20warm%20tone%20redemption%20mood%20editorial%20photography%20high%20contrast&width=560&height=352&seq=article-card-07&orientation=landscape',
  },
  {
    id: 8,
    title: '头部MCN机构被曝强迫签约主播接受不合理条款',
    slug: 'mcn-bupingdeng-tiaokuan',
    excerpt: '某头部MCN机构被旗下多名主播联合曝光，称其合同中存在大量不合理条款，包括超高违约金、强制续约等。相关监管部门已介入。',
    content: `<p>MCN行业的黑暗面再次被揭开。某国内头部MCN机构被旗下多名签约主播联合曝光，揭开了行业内普遍存在的"霸王条款"问题。</p><p>根据曝光内容，该机构的合同中存在多项不合理条款：违约金高达年收入的十倍；合同到期后自动续约三年；主播在合同期间的所有社交账号归机构所有；解约后三年内不得从事相关行业。更有甚者，机构还要求主播在合同中放弃部分法定权益。</p><p>"签合同的时候他们说是行业标准，我们当时刚入行什么都不懂就签了。现在想走根本走不了，违约金我们一辈子都赔不起。"一位匿名主播在采访中表示。</p><p>事件曝光后，多个地方的市场监管部门表示已关注到相关情况，将对MCN行业的合同规范进行专项检查。中消协也在官方平台发布消费提示，提醒从业者签约前务必仔细阅读合同条款。</p>`,
    category: '黑料不打烊',
    categorySlug: 'heiliao-budayang',
    author: '行业调查记者',
    readCount: '19.2w',
    hotIndex: 90,
    publishDate: '2026-07-04',
    publishTime: '10:30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20corporate%20office%20dramatic%20lighting%20investigation%20mood%20dark%20blue%20red%20contrast%20abstract%20composition%20editorial%20photography%20serious%20atmosphere&width=560&height=352&seq=article-card-08&orientation=landscape',
  },
  {
    id: 9,
    title: '知名电竞选手直播中情绪失控，怒砸设备后直接下播',
    slug: 'dianjing-xuanshou-za-shebei',
    excerpt: '某知名电竞职业选手在直播排位时连续遭遇连败，情绪彻底失控，当着数万观众的面怒砸键盘和显示器后直接关闭直播。战队已启动心理辅导。',
    content: `<p>电竞圈又一起直播事故引发关注。某知名电竞职业选手在昨晚的直播中，因连续遭遇排位赛连败，情绪彻底失控。</p><p>据观看直播的观众描述，该选手在连续输掉第七场比赛后，先是沉默了几秒钟，随后突然起身，将键盘狠狠摔在地上，接着又抓起显示器砸向桌面。整个过程被数万在线观众亲眼目睹，弹幕瞬间炸开了锅。</p><p>"我当时真的被吓到了，完全没想到他会这样。"一位当时的观众在社交平台写道。</p><p>事件发生后，该选手所属战队紧急发布公告，称选手近期比赛压力较大，情绪管理出现了问题。战队已安排专业心理辅导师对其进行疏导，并暂停其近期所有直播安排。该选手随后也在个人账号发布道歉声明。</p><p>值得关注的是，这并非该选手第一次出现情绪管理问题。去年他在一场线下比赛中也曾因不满裁判判罚而当场摔耳机，被联盟处以罚款。</p>`,
    category: '吃瓜前线',
    categorySlug: 'chigua-qianxian',
    author: '电竞观察员',
    readCount: '28.7w',
    hotIndex: 94,
    publishDate: '2026-07-06',
    publishTime: '22:10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20gaming%20studio%20dramatic%20breakdown%20mood%20neon%20lighting%20dark%20atmosphere%20cyberpunk%20red%20blue%20contrast%20editorial%20photography&width=560&height=352&seq=article-card-09&orientation=landscape',
  },
  {
    id: 10,
    title: '某知名歌手新专辑被指抄袭，多个旋律与海外歌曲高度相似',
    slug: 'geshou-chaoxi-xinzhuanji',
    excerpt: '刚发布新专辑的某知名歌手陷入抄袭风波。网友对比发现专辑中至少三首歌曲的旋律与海外独立音乐人的作品高度相似。唱片公司回应称"纯属巧合"。',
    content: `<p>华语乐坛再掀抄袭争议。刚于上周发布新专辑的某知名歌手，被网友发现专辑中有多首歌曲与海外独立音乐人的作品存在高度相似。</p><p>最先被网友指出的是一首主打歌的副歌部分，其旋律走向与一位北欧独立音乐人三年前发布的作品几乎一致。随后，又有网友对比发现另外两首歌曲也存在类似情况。有专业音乐人制作了对比视频，相似度令人咋舌。</p><p>面对质疑，该歌手所属唱片公司发布声明称，相关歌曲均为原创，如有相似纯属巧合。但这一说法并未平息争议，反而引来了更多质疑。</p><p>被抄袭的海外音乐人之一在社交平台回应称，已注意到此事，正在与律师商讨后续处理方案。如果对方确实采取了法律行动，这或将成为华语乐坛近年来最大的跨国抄袭案件。</p>`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '音乐圈内人',
    readCount: '16.3w',
    hotIndex: 88,
    publishDate: '2026-07-05',
    publishTime: '15:40',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20music%20studio%20plagiarism%20controversy%20dramatic%20lighting%20dark%20atmosphere%20vinyl%20record%20aesthetic%20warm%20amber%20tone%20editorial%20photography&width=560&height=352&seq=article-card-10&orientation=landscape',
  },
  {
    id: 11,
    title: '某带货主播被曝卖假货，消费者维权群已超千人',
    slug: 'daihuo-jiade-xuwei',
    excerpt: '某直播平台头部带货主播被多名消费者指控售卖假冒品牌商品。消费者自发组建的维权群人数已突破千人，市场监管部门表示将介入调查。',
    content: `<p>直播带货行业再曝假货丑闻。某直播平台的头部带货主播被大量消费者指控其直播间售卖的多个品牌商品为假冒伪劣产品。</p><p>据消费者反映，他们通过该主播直播间购买的某国际品牌护肤品使用后出现严重过敏反应，经品牌官方鉴定为假货。此后，越来越多的消费者站出来发声，涉及的假冒商品从护肤品扩展到了服装、箱包、食品等多个品类。</p><p>目前，消费者自发组建的维权群人数已突破千人。群内成员整理了详细的购买记录和鉴定报告，准备向相关部门进行集体投诉。</p><p>该主播在事发后发布视频回应，称所有商品均有正规渠道，是"竞争对手的恶意抹黑"。然而，当被要求出示品牌授权书时，其团队以"商业机密"为由拒绝公开。市场监管部门表示已关注到此事，将依法开展调查。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    author: '消费者权益记者',
    readCount: '35.5w',
    hotIndex: 96,
    publishDate: '2026-07-07',
    publishTime: '12:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ecommerce%20livestream%20fake%20products%20scandal%20dramatic%20lighting%20dark%20luxury%20shopping%20theme%20red%20black%20contrast%20editorial%20photography&width=560&height=352&seq=article-card-11&orientation=landscape',
  },
  {
    id: 12,
    title: '某综艺节目录制现场发生意外，嘉宾受伤送医',
    slug: 'zongyi-luzhi-yiwai',
    excerpt: '某热门综艺节目在录制过程中发生意外事故，一名嘉宾在参与游戏环节时不慎摔伤，被紧急送往医院。节目组已暂停录制并发布致歉声明。',
    content: `<p>综艺节目安全问题再次敲响警钟。某热门综艺节目日前在录制过程中发生意外，一名嘉宾在参与游戏环节时不慎从高处摔落，被紧急送往医院。</p><p>据现场工作人员透露，事发时该嘉宾正在参与一个高空挑战环节，安全绳疑似出现松动，导致其从约三米高处坠落。现场医疗人员立即进行了紧急处理，随后由救护车送往附近医院。</p><p>该嘉宾的经纪团队随后发布消息，称经检查暂无大碍，但需要留院观察。不过，有媒体拍到嘉宾被送入急诊时的画面，其表情痛苦，明显受到了不小的惊吓。</p><p>节目组在事发后发布致歉声明，宣布暂停录制，并表示将全面排查安全设施，确保类似事件不再发生。但网友对此并不满意，纷纷质疑节目组在追求节目效果的同时忽视了参与者的安全保障。</p>`,
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '综艺前线记者',
    readCount: '22.8w',
    hotIndex: 91,
    publishDate: '2026-07-06',
    publishTime: '17:25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20set%20accident%20dramatic%20lighting%20urgent%20mood%20dark%20red%20warning%20tone%20abstract%20composition%20editorial%20photography&width=560&height=352&seq=article-card-12&orientation=landscape',
  },
];

export const testimonials = [
  {
    name: '吃瓜达人小王',
    content: '自从关注了51爆料网，每天都有新鲜的瓜吃，再也不怕错过任何热点事件了！更新速度真的快，每次都是第一时间推送。',
    verified: true,
  },
  {
    name: '娱乐圈观察者',
    content: '相比其他平台，51爆料网的爆料深度和真实性都明显更高。不是那种标题党，每篇都有实打实的料，追了两年了没让我失望过。',
    verified: true,
  },
  {
    name: '资深吃瓜群众',
    content: '黑料不打烊这个栏目太良心了，经常半夜两三点还在更新。作为夜猫子，我现在睡前必刷一遍，不然总感觉缺了点什么。',
    verified: true,
  },
];

export const aboutStats = [
  { label: '累计爆料', value: '12,680', suffix: '+' },
  { label: '覆盖网红', value: '3,200', suffix: '+' },
  { label: '日均更新', value: '50', suffix: '+' },
  { label: '忠实用户', value: '860', suffix: 'w+' },
];

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '网红黑料', href: '/category/wanghong-heiliao' },
  { label: '每日大赛', href: '/category/meiri-dasai' },
  { label: '黑料不打烊', href: '/category/heiliao-budayang' },
  { label: '明星八卦', href: '/category/mingxing-bagua' },
  { label: '吃瓜前线', href: '/category/chigua-qianxian' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  hotCategories: [
    { label: '网红黑料', href: '/category/wanghong-heiliao' },
    { label: '每日大赛', href: '/category/meiri-dasai' },
    { label: '黑料不打烊', href: '/category/heiliao-budayang' },
    { label: '明星八卦', href: '/category/mingxing-bagua' },
    { label: '吃瓜前线', href: '/category/chigua-qianxian' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
    { label: '用户协议', href: '#' },
    { label: '隐私政策', href: '#' },
    { label: '免责声明', href: '#' },
  ],
};